export default __webpack_public_path__ + "static/media/notify.b42790c1.svg";